/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Show_Page_BreaksInputs */



/**
* | output |
* | --- |
* | "Show page breaks" |
*
* @param {Editor_Show_Page_BreaksInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const editor_show_page_breaks = /** @type {((inputs?: Editor_Show_Page_BreaksInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Show_Page_BreaksInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Seitenumbrüche anzeigen")
	return /** @type {LocalizedString} */ ("Show page breaks")
});